import { LiveVideoRoomState } from '.';

import { getEnv, getCloudFrontUrl } from '@/constants';
import { RootState } from '@/store';
import { getStreamingLocation } from '@/utils/cdnUtils';

const getters = {
  videoStreamingLocation(state: LiveVideoRoomState, g: any, rootState: RootState, rootGetters: any) {
    return getStreamingLocation();
  },
  fillerSlideUrl(state: LiveVideoRoomState, g: any, rootState: RootState, rootGetters: any) {
    if (rootState.event?.event?.broadcast_filler_image_s3_path) {
      return `${getCloudFrontUrl('CLOUDFRONT_URL')}${rootState.event?.event?.broadcast_filler_image_s3_path}`;
    }

    return `${getCloudFrontUrl('CLOUDFRONT_URL')}Goldcast_filler_slide.png`;
  },
  isHlsNetworkLoading(state: LiveVideoRoomState, g: any, rootState: RootState, rootGetters: any) {
    const isLoadError = state.isHLSFragLoadError || state.isHLSLevelLoadError || state.isHLSManifestLoadError;

    if (isLoadError && state.hasVideoBufferPlaybackStalled) {
      return true;
    }

    return false;
  }
};

export default getters;
export type LiveVideoRoomGetters = typeof getters;
